export const contestExampleData = [
  {
    text: "Great experience! I’ll be back soon.",
    avatar: "https://randomuser.me/api/portraits/thumb/men/75.jpg",
    name: "Ophelia Moreno",
    company: "Company Name",
    designers: "433",
    entries: "1392",
    budget: "$372",
    images: [
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600"
    ]
  },
  {
    text: "Great experience! I’ll be back soon.",
    avatar: "https://randomuser.me/api/portraits/thumb/men/75.jpg",
    name: "Ophelia Moreno",
    company: "Company Name",
    designers: "433",
    entries: "1392",
    budget: "$372",
    images: [
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600"
    ]
  },
  {
    text: "Great experience! I’ll be back soon.",
    avatar: "https://randomuser.me/api/portraits/thumb/men/75.jpg",
    name: "Ophelia Moreno",
    company: "Company Name",
    designers: "433",
    entries: "1392",
    budget: "$372",
    images: [
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600"
    ]
  },
  {
    text: "Great experience! I’ll be back soon.",
    avatar: "https://randomuser.me/api/portraits/thumb/men/75.jpg",
    name: "Ophelia Moreno",
    company: "Company Name",
    designers: "433",
    entries: "1392",
    budget: "$372",
    images: [
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600",
      "https://source.unsplash.com/random/600x600"
    ]
  }
];
